import { Dialog } from "./Dialog";

export class DialogController extends createjs.Container {
    private dialogMask: createjs.Shape;
    private dialogContainer: createjs.Container;
    private dialogList: Dialog[] = [];
    private dialogShowInfos: { dialog: createjs.DisplayObject, bMask: boolean }[] = [];
    static instance: DialogController;
    static eventTagShow = 'DialogControllerShow';
    static eventTagShowAnimTick = 'DialogControllerShowAnimTick';
    static eventTagHide = 'DialogControllerHide';
    private bMask: boolean = false;
    bAnime: boolean = false;
    constructor(width: number, height: number, alpha: number = 0.5) {
        super();
        this.dialogMask = new createjs.Shape();
        this.dialogMask.graphics
            .beginFill('#000')
            .drawRect(0, 0, width, height);
        this.dialogMask.alpha = alpha;

        const dialogHitShape = new createjs.Shape();
        dialogHitShape.graphics
            .beginFill('#F00')
            .drawRect(0, 0, width, height);
        this.dialogMask.hitArea = dialogHitShape;

        this.dialogMask.on('click', () => { });
        this.dialogMask.visible = false;

        this.dialogContainer = new createjs.Container();
        this.dialogContainer.setBounds(0, 0, width, height);

        this.addChild(this.dialogMask);
    }
    /*
        static get instance() {
            if (this._instance1 == null) {
                this._instance1 = new this();
            }
            return this._instance1;
        }
        static getInstancePresetAlpha(alpha: number): DialogController {
            if (this._instance1 == null) {
                this._instance1 = new this(alpha);
            } else {
                console.log("DialogController: instance1 already constructed / cannot initialize with alpha: " + alpha);
            }
            return this._instance1;
        }*/

    setMaskAlpha(alpha: number) {
        this.dialogMask.alpha = alpha;
    }

    push(dialog: Dialog, x?: number, y?: number): void {
        this.dialogList.push(dialog);
        dialog.hide();
        if (x && y) {
            dialog.set({ x: x, y: y });
        } else {
            dialog.set({
                x: Math.floor((this.dialogContainer.getBounds().width - dialog.width) / 2),
                y: Math.floor((this.dialogContainer.getBounds().height - dialog.height) / 2 - 20)
            });
        }
    }

    showDialog(dialog: Dialog, bMask: boolean = true, bTween: boolean = true): void {
        if (this.bAnime) return;
        this.bMask = bMask;
        const obj: createjs.DisplayObject = dialog.getDisplayObject();

        this.addChild(obj);
        this.dialogShowInfos.push({ dialog: obj, bMask: this.bMask });

        if (this.bMask) {
            this.setChildIndex(this.dialogMask, this.getChildIndex(obj) - 1);
            this.dialogMask.visible = true;
        }

        dialog.show();
        if (this.bMask) {
            this.dispatchEvent(new createjs.Event(DialogController.eventTagShow, true, false));
        }

        const x0 = dialog.x;
        const y0 = dialog.y;
        if (bTween) {
            dialog.set({ alpha: 0, scaleX: 0.5, scaleY: 0.5, x: x0 + dialog.width * 0.25, y: y0 + dialog.height * 0.25 })
            createjs.Tween.get(dialog, { ignoreGlobalPause: true })
                .call(() => {
                    this.bAnime = true;
                })
                .to({ alpha: 1, scaleX: 1, scaleY: 1, x: x0, y: y0 }, 200, createjs.Ease.quadInOut)
                .call(() => {
                    this.bAnime = false;
                })
                .addEventListener("change", () => {
                    dialog.dispatchEvent(new createjs.Event(DialogController.eventTagShowAnimTick, true, false));
                })
                ;
        } else {
            dialog.set({ x: x0, y: y0 });
        }
    }

    hideDialog(dialog: Dialog): void {
        const obj: createjs.DisplayObject = dialog.getDisplayObject();
        this.removeChild(obj);
        // console.log(this.dialogShowInfos);
        this.dialogShowInfos = this.dialogShowInfos.filter(info => {
            return (info.dialog !== dialog)
        });

        if (this.dialogShowInfos.length === 0) {
            this.dialogMask.visible = false;
        } else {
            let bMask: boolean = false
            this.dialogShowInfos.forEach(infos => {
                if (infos.bMask) {
                    this.addChild(this.dialogMask)
                    this.addChild(infos.dialog);
                    bMask = true;
                }
            })
            if (!bMask) this.dialogMask.visible = false;
        }
        // console.log(this.dialogShowInfos);
        if (this.bMask) {
            this.dispatchEvent(new createjs.Event(DialogController.eventTagHide, true, false));
        }
        dialog.hide();
    }

    /**
     * 全部のダイアログを閉じる
     */
    hideAllDialog(): void {
        this.dialogList.forEach(dialog => {
            dialog.hide();
        });
        this.dialogMask.visible = false;
    }

    /**
     * ダイアログのマスクだけ表示する（ユーザに画面操作させたくない時に使用）
     */
    showDialogMask(): void {
        this.dialogMask.visible = true;
    }
    hideDialogMask(): void {
        this.dialogMask.visible = false;
    }


}
